const STORAGE_KEY = "wedding-uploader-name";

/** Display name the guest typed in once at the password gate, persisted
 * per-browser so it doesn't need to be re-entered on every upload. */
export function getUploaderName(): string | null {
  return localStorage.getItem(STORAGE_KEY);
}

export function setUploaderName(name: string): void {
  localStorage.setItem(STORAGE_KEY, name.trim());
}
